import { useTranslation } from "react-i18next";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";

export function EditButton(props: IconButtonProps) {
  const { t } = useTranslation();

  return (
    <Tooltip title={<div>{t("common.edit")}</div>}>
      <span>
        <IconButton {...props} size="large">
          <EditIcon color={props.disabled ? "disabled" : "primary"} />
        </IconButton>
      </span>
    </Tooltip>
  );
}
